import * as Sentry from "@sentry/react";

Sentry.init({
    dsn: "https://7ae168519bfcbe9450c4e56082700d31@o4508601115672576.ingest.us.sentry.io/4509161836904448",
    enabled: process.env.ENVIRONMENT === 'production',
    integrations: [],
});
const originalConsoleError = console.error;
console.error = (...args) => {
    const err = args.find(arg => arg instanceof Error);
    if (err) {
        Sentry.captureException(err);
    }
    originalConsoleError(...args);
};
